<template>
  <a-modal
    :width="1000"
    :visible="visible"
    title="详情"
    @ok="cancel"
    @cancel="cancel"
  >
    <a-descriptions title="任务要求" :column="2" bordered>
      <a-descriptions-item label="任务名称">
        {{ modal.workerName }}
      </a-descriptions-item>
      <a-descriptions-item label="任务描述">
        <span v-html="modal.content"></span>
      </a-descriptions-item>
      <a-descriptions-item label="开始时间">
        {{ modal.startTime }}
      </a-descriptions-item>
      <a-descriptions-item label="截止时间">
        {{ modal.endTime }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="文件上传"
      :column="3"
      bordered
      style="margin-top:16px"
    >
      <a-descriptions-item label="文件列表">
        <div class="fileItem" v-for="item in modal.attachments" :key="item.id">
          <img :src="item.fileType | getImgPath" width="30" height="30" />
          <a :href="item.filePath">{{ item.fileName }}</a>
        </div>
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      //modal
      visible: false,
      modal: {}
    };
  },
  filters: {
    getImgPath(t) {
      let img = require("@/assets/imgs/resource/btn_word.png");
      switch (t) {
        case "doc":
        case "docx":
          img = require("@/assets/imgs/resource/btn_word.png");
          break;
        case "xls":
        case "xlsx":
          img = require("@/assets/imgs/resource/btn_xls.png");
          break;
        case "ppt":
        case "pptx":
          img = require("@/assets/imgs/resource/btn_ppt.png");
          break;
        case "pdf":
          img = require("@/assets/imgs/resource/btn_pdf.png");
          break;
      }

      return img;
    }
  },
  methods: {
    show(record) {
      this.visible = true;
      console.log(record);
      if (record) {
        this.modal = record;

        this.modal.startTime = moment(this.modal.startTime).format("YYY-MM-DD");
        this.modal.endTime = moment(this.modal.endTime).format("YYY-MM-DD");
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
    }
  }
};
</script>
<style lang="less" scoped>
.fileItem {
  margin: 6px 0;
}
</style>
